import { render, staticRenderFns } from "./RefundDialog.vue?vue&type=template&id=9c784504&scoped=true&"
import script from "./RefundDialog.vue?vue&type=script&lang=js&"
export * from "./RefundDialog.vue?vue&type=script&lang=js&"
import style0 from "./RefundDialog.vue?vue&type=style&index=0&id=9c784504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c784504",
  null
  
)

export default component.exports